(function () {
  'use strict';

  function clamp(val, min, max) {
    return Math.min(Math.max(val, min), max);
  }

  function VNSlider(el) {
    this.el = el;
    this.viewport = el.querySelector('.vn-slider__viewport');
    this.handle = el.querySelector('.vn-slider__handle');
    this.btns = el.querySelectorAll('.vn-slider__btn');
    this.pos = 50;
    this._dragging = false;
    this._bindEvents();
    this._setPos(50, false);
  }

  VNSlider.prototype._setPos = function (p, animate) {
    p = clamp(p, 0, 100);
    this.pos = p;
    if (animate) {
      this.el.setAttribute('data-vn-animate', '');
    } else {
      this.el.removeAttribute('data-vn-animate');
    }
    this.el.style.setProperty('--vn-pos', p + '%');
    this.handle.setAttribute('aria-valuenow', String(Math.round(p)));
    this.handle.setAttribute('aria-valuetext', Math.round(p) + ' Prozent Vorher sichtbar');
  };

  VNSlider.prototype._posFromX = function (clientX) {
    var rect = this.viewport.getBoundingClientRect();
    return ((clientX - rect.left) / rect.width) * 100;
  };

  VNSlider.prototype._bindEvents = function () {
    var self = this;

    // Pointer capture on handle for drag
    this.handle.addEventListener('pointerdown', function (e) {
      e.preventDefault();
      self._dragging = true;
      self.handle.setPointerCapture(e.pointerId);
    });

    this.handle.addEventListener('pointermove', function (e) {
      if (!self._dragging) return;
      self._setPos(self._posFromX(e.clientX), false);
    });

    this.handle.addEventListener('pointerup', function () {
      self._dragging = false;
    });

    this.handle.addEventListener('pointercancel', function () {
      self._dragging = false;
    });

    // Click on viewport outside handle → jump (no animation per spec)
    this.viewport.addEventListener('click', function (e) {
      if (self.handle.contains(e.target)) return;
      self._setPos(self._posFromX(e.clientX), false);
    });

    // Keyboard: ←/→ ±5%, Home/End für 0%/100%
    this.handle.addEventListener('keydown', function (e) {
      var p = self.pos;
      if (e.key === 'ArrowLeft')       { p -= 5; e.preventDefault(); }
      else if (e.key === 'ArrowRight') { p += 5; e.preventDefault(); }
      else if (e.key === 'Home')       { p = 0;   e.preventDefault(); }
      else if (e.key === 'End')        { p = 100; e.preventDefault(); }
      else { return; }
      self._setPos(p, false);
    });

    // A11y-Buttons: animiert (transition via CSS @property --vn-pos)
    this.btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        self._setPos(btn.dataset.vnShow === 'before' ? 100 : 0, true);
      });
    });
  };

  function init() {
    document.querySelectorAll('.vn-slider').forEach(function (el) {
      new VNSlider(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
